// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2ogk6","dot":"styles_dot__6uTzH","active":"styles_active__2nE0K"};